<template>

  <div id="app">

    <!-- Header -->
    <div class="col-12 bg-header">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-2 text-center">
            <img src="https://www.rueden.de/images/Logo-Horizontal-inversion.png" alt="VON RUEDEN"/>
          </div>
          <div class="col-12 col-md-8 text-center">
            <h1>Abmahnhelfer - Vollmachtserteilung Filesharing</h1>
          </div>
        </div>
      </div>
    </div>

    <!-- Upload in Progress -->
    <div v-if="uploadInProgress" class="upload-progress">
      <div class="spinner-border" role="status">
        <span class="sr-only">Lade ...</span>
      </div>
      <h2>Bitte warten. Dokument wird hochgeladen.</h2>
    </div>

    <!-- VM noch nicht eingegangen -->
    <div v-if="vmErteilt !== true">

      <!-- 1. Stammdaten -->
      <div class="container pt-5 pb-5 mb-5" v-if="schritt === 1">
        <form id="form_1" autocomplete="off">

          <Schrittanzeige :schritt="1"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">

                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">1. Kontaktdaten</h2>
                  </div>
                </div>

                <div class="row">

                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="radio" id="woman" value="Frau" v-model="stammdaten.anrede" name="anrede" required/>
                      <label for="woman" class="">Frau</label>
                    </div>
                    <div class="form-checkboxes form-display-inline">
                      <input id="men" type="radio" value="Herr" v-model="stammdaten.anrede" name="anrede" required/>
                      <label for="men" class="">Herr</label>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="rueden-input">
                      <label for="vorname">Vorname</label>
                      <input id="vorname" class="form-control" type="text" v-model="stammdaten.vorname" name="vorname" required/>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="rueden-input">
                      <label for="nachname">Nachname</label>
                      <input id="nachname" class="form-control" type="text" v-model="stammdaten.nachname" name="nachname" required/>
                    </div>
                  </div>

                  <div class="col-lg-5">
                    <div class="rueden-input">
                      <label for="strasse">Straße und Hausnummer</label>
                      <input id="strasse" class="form-control" type="text" v-model="stammdaten.strasse" name="strasse" required/>
                    </div>
                  </div>

                  <div class="col-lg-2">
                    <div class="rueden-input">
                      <label for="plz">PLZ</label>
                      <input id="plz" class="form-control" type="text" v-model="stammdaten.plz" name="plz" required/>
                    </div>
                  </div>

                  <div class="col-lg-5">
                    <div class="rueden-input">
                      <label for="ort">Ort</label>
                      <input id="ort" class="form-control" type="text" v-model="stammdaten.ort" name="ort" required/>
                    </div>
                  </div>

                  <div class="col-lg-4 d-none">
                    <div class="rueden-input">
                      <label for="geburtsdatum">Geburtsdatum</label>
                      <input placeholder="TT.MM.JJJJ" id="geburtsdatum" class="form-control" type="text" v-model="stammdaten.geburtsdatum" name="geburtsdatum"/>
                    </div>
                  </div>

                  <div class="col-lg-12 text-right">
                    <button class="btn btn-primary-click" @click="nextStep(1)">
                      Weiter <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    </button>
                  </div>

                </div>

              </div>
            </div>
          </div>

        </form>
      </div>

      <!-- 2. PKW Angaben  -->
      <div class="container pt-5 pb-5" v-if="schritt === 2">
        <form id="form_2" autocomplete="off">

          <Schrittanzeige :schritt="2"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">
              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">2. Angaben zur Abmahnung</h2>
                  </div>
                </div>

                <div class="row">

                  <div class="col-lg-6">
                    <label for="kanzlei" class="lead">Abmahnende Kanzlei</label>
                    <div class="rueden-input">
                      <input class="form-control" type="text" v-model="falldaten.kanzlei" id="kanzlei" name="kanzlei" required/>
                    </div>
                  </div>

                  <div class="col-lg-6">
                    <div class="rueden-input">
                      <label for="forderung" class="lead">Forderungshöhe (in Euro)</label>
                      <input class="form-control" type="text" v-model="falldaten.forderung" id="forderung" name="forderung" required/>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="rueden-input">

                      <label for="files" class="lead font-weight-bold">Abmahnung</label>

                      <p>Laden Sie hier bitte das Abmahnschreiben hoch.</p>

                      <div class="border p-4">

                        <div id="uploadedFiles" class="mb-4" v-if="files">
                          <ul>
                            <li v-for="(file, index) in files" :class="'file_'+index" :key="index"><i @click="removeFile(index)" style="cursor: pointer" class="fa fa-trash text-danger float-right"></i> {{ file.name }}</li>
                          </ul>
                        </div>

                        <input
                            @change="uploadFile"
                            class="d-none"
                            type="file"
                            multiple
                            id="files"
                            name="files"
                            ref="files"
                            required />

                        <button class="btn btn-primary-blue" type="button" @click="chooseFile">
                          <i class="fa fa-upload"></i>
                          Hochladen
                        </button>

                        <small class="text-secondary font-italic">Mehrere Dateien sind erlaubt.</small>

                      </div>

                    </div>
                  </div>

                  <div class="col-lg-12">
                    <hr />
                    <div class="rueden-input mb-0">
                      <div class="lead font-weight-bold">Vergleichsbereitschaft</div>
                      <div class="control-select mb-0 mt-3">
                        <div class="form-checkboxes form-display-inline">
                          <input type="radio" id="ja" value="Einverstanden" v-model="falldaten.vergleichsbereitschaft" name="vergleichsbereitschaft" required/>
                          <label for="ja" class="">Ich wäre mit einem Vergleich von 50 bis 70% der Forderungshöhe einverstanden.</label>
                        </div>
                        <div class="form-checkboxes form-display-inline">
                          <input id="nein" type="radio" value="Nicht einverstanden" v-model="falldaten.vergleichsbereitschaft" name="vergleichsbereitschaft" required/>
                          <label for="nein" class="">Nein, ich wünsche keine Zahlung an die Abmahnkanzlei.</label>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-12 mt-4 text-right">
                    <button id="to-step-3" @click="nextStep(2)" type="submit" class="btn btn-primary-click">
                      Weiter &nbsp; <i class="fa fa-angle-double-right" aria-hidden="true"></i></button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="hidden_submit_3" value="jetzt"/>

        </form>
      </div>

      <!-- 3. Preise -->
      <div class="container pt-5 pb-5" v-if="schritt === 3">
        <form id="form_3" autocomplete="off">

          <Schrittanzeige :schritt="3"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">

              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0">3. Umfang der Vertretung</h2>

                    <p class="mt-2 mb-4">Bitte wählen Sie das gewünschte Paket aus.</p>

                    <div class="row">

                      <div class="col-lg-6">
                        <div class="pricing-table">
                        <h3 class="p-4 m-0 font-weight-bold text-center text-white" style="background: #638c1c;">
                          Einmalhelfer
                        </h3>
                        <div class="p-4 text-white" style="background: #003764;">
                          <ul class="m-0 py-0 px-3">
                            <li><span class="font-weight-bold"><span style="background: #638c1c; border-radius: 15px; text-decoration: underline" class="px-2 py-1">1</span> Vorgehen</span> gegen die konkrete Filesharing-Abmahnung</li>
                            <li><span class="font-weight-bold">Anwälte mit großer Expertise</span> im Filesharing-Recht betreuen Ihren Fall</li>
                            <li><span class="font-weight-bold">Rund um die Uhr</span> erreichbar per Mail und Telefon</li>
                          </ul>
                          <div class="font-weight-bold mt-3 lead">
                            <i class="fa fa-check-circle" style="color: #638c1c"></i> Preisgarantie
                          </div>
                        </div>
                        <div class="px-4 py-3 font-weight-bold text-center text-white" style="background: #638c1c;">
                          <h2 class="text-white font-weight-bold m-0">€ 249</h2>
                          <div class="small">Inkl. 19% MwSt.</div>
                        </div>
                          <div class="py-3 text-center mb-4" style="background: #efefef">
                            <button class="btn btn-primary-blue" @click="nextStep(3); falldaten.umfang='Eine Abmahnung'">Auswählen</button>
                          </div>
                      </div>
                      </div>

                      <!-- Grün: 638c1c, Blau: 003764, Gelb: ffdd00, HellGrün: b6db00 -->

                      <div class="col-lg-6">
                        <div class="pricing-table">
                          <h3 class="p-4 m-0 font-weight-bold text-center text-white" style="background: #638c1c;">
                            Abmahnhelfer Komplett
                          </h3>
                          <div class="p-4 text-white" style="background: #003764;">
                            <ul class="m-0 py-0 px-3">
                              <li><span class="font-weight-bold"><span style="background: #638c1c; border-radius: 15px; text-decoration: underline" class="px-2 py-1">Alle</span> Vorgehen</span> gegen alle Filesharing-Abmahnungen</li>
                              <li><span class="font-weight-bold">Anwälte mit großer Expertise</span> im Filesharing-Recht betreuen Ihren Fall</li>
                              <li><span class="font-weight-bold">Rund um die Uhr</span> erreichbar per Mail und Telefon</li>
                            </ul>
                            <div class="font-weight-bold lead" style="margin-top:39px">
                              <i class="fa fa-check-circle" style="color: #638c1c"></i> Preisgarantie
                            </div>
                          </div>
                          <div class="px-4 py-3 font-weight-bold text-center text-white" style="background: #638c1c;">
                            <div class="badge badge-warning" style="position:absolute; margin-top: -25px; margin-left: -65px">Bis zu €501 gespart</div>
                            <h2 class="text-white font-weight-bold m-0">€ 495</h2>
                            <div class="small">Inkl. 19% MwSt.</div>
                          </div>
                          <div class="py-3 text-center mb-4" style="background: #efefef">
                            <button class="btn btn-primary-blue" @click="nextStep(3); falldaten.umfang='Mehrere Abmahnungen'">Auswählen</button>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- 4. Vollmacht -->
      <div class="container pt-5 pb-5" v-if="schritt === 4">
        <form id="form_4" autocomplete="off">

          <Schrittanzeige :schritt="4"/>

          <div class="row">
            <div class="col-12 col-lg-8 offset-lg-2">

              <div class="formular-box">
                <div class="row">
                  <div class="col-12">
                    <h2 class="mt-0 pt-0 mb-0 pb-5">Erteilung der Vollmacht</h2>
                  </div>
                </div>

                <div class="row">

                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="checkbox" :checked="zustimmung_vollmacht === 'Ja'" id="zustimmung_vollmacht" v-model="zustimmung_vollmacht" name="zustimmung_vollmacht" required/>
                      <label for="zustimmung_vollmacht"><strong>Hiermit erteile ich den Rechtsanwält/innen der
                        Kanzlei VON RUEDEN – Partnerschaft von Rechtsanwälten, Leipziger Platz 9, 10117 Berlin</strong>,
                        wegen Urheberrechtsverletzung Vollmacht zur außergerichtlichen Vertretung gegen alle in Frage kommenden Gegner.</label>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="checkbox" id="zustimmung_kosten" v-model="zustimmung_kosten" name="zustimmung_kosten" required/>
                      <label for="zustimmung_kosten"><strong>Hiermit schließe ich mit den Rechtsanwält/innen der Kanzlei
                        VON RUEDEN – Partnerschaft von Rechtsanwälten, Leipziger Platz 9, 10117 Berlin,</strong>
                        folgende Vergütungsvereinbarung: Die Rechtanwält/innen erhalten für die außergerichtliche
                        Tätigkeit in der Angelegenheit wegen Urheberrechtsverletzung eine pauschale Vergütung von

                        <span v-if="falldaten.umfang === 'Eine Abmahnung'">249,00</span>
                        <span v-else>495,00</span>

                         EUR (inklusive 19% Mehrwertsteuer).
                      </label>
                    </div>
                  </div>

                </div>

                <div class="row">

                  <div class="col-12">
                    <div class="form-checkboxes form-display-inline">
                      <input type="checkbox" id="vollmachtFirstCheck" v-model="zustimmung_datenschutz_und_widerruf"
                             name="zustimmung_datenschutz_und_widerruf" required/>
                      <label for="vollmachtFirstCheck">Ich habe die <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
                        und die <a href="#" v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</a> gelesen.</label>
                    </div>
                  </div>

                </div>

                <div class="row mt-4">
                  <div class="col-12">

                    <div class="unterschrift">

                      <!-- Automatische Unterschrift -->
                      <div id="unterschrift_automatisch" v-if="stammdaten.vorname && unterschrift_typ == 'automatisch'">
                        <div class="bg-white p-3">
                          <div style="max-width:420px">
                            <span style="font-weight:bold; font-size:300%; float: left; margin-right:20px;">X</span>
                            <span class="schreibschrift" style="float:left; margin-top:17px;">{{
                                stammdaten.vorname.substr(0, 1)
                              }}. {{ stammdaten.nachname }}</span>
                            <div class="clearfix"></div>
                            <hr/>
                          </div>
                        </div>
                      </div>

                      <!-- Manuelle Unterschrift -->
                      <div id="unterschrift_manuell" v-if="unterschrift_typ == 'manuell'">

                        <div class="bg-white mb-2 p-3">
                          <div style="max-width:420px;">
                            <div style="border: solid 1px #ddd; margin-bottom: 10px;">
                              <VueSignaturePad width="380px" height="200px" ref="signaturePad" :options="{onEnd}"/>
                            </div>
                            <span @click="clearSignature()" class="cursor-pointer"><i
                                class="fa fa-remove text-danger"></i> Unterschrift erneut eingeben </span>
                          </div>
                        </div>

                      </div>

                      <div class="row mt-3">
                        <div class="col-lg-6">
                          <i class="fa fa-check-circle text-success"></i> Diese Unterschrift ist ausreichend
                        </div>
                        <div class="col-lg-6 text-right">
													<span class="cursor-pointer" @click="changeSignatureMode()">
														<i class="fa fa-edit text-danger "></i> Mit Finger / Maus unterschreiben
													</span>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12 mt-4">

                    <button id="vollmacht_erteilen" @click="submitVM" type="submit" class="btn btn-primary-click">
                      Vollmacht &amp; Mandat erteilen &nbsp;
                      <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                    </button>

                  </div>
                </div>

              </div>
            </div>
          </div>

          <input type="submit" id="submit_vm"/>

        </form>
      </div>

    </div>

    <!-- 7. Alles eingereicht -->
    <div id="vielen_dank" style="display: none" v-if="!falldaten.rechnungBezahlt">

      <div class="col-12 col-lg-8 offset-lg-2 mb-5">
        <div class="formular-box">
          <div class="row">
            <div class="col-12 text-center">

              <div class="alert alert-info">
                <h2 class="mt-0 pt-0 mb-0 pb-4">Vielen Dank</h2>
                <p class="lead">Bitte fahren Sie nun mit der Zahlung fort.</p>
              </div>

              <!-- Bitte warten -->
              <div id="paypal_bitte_warten" class="border border-light p-4 text-center bg-light mb-3" style="box-shadow: 0 0 15px rgba(0,0,0,0.1); display: none">
                <h2>Bitte warten Sie!</h2>
                <div class="spinner-border" role="status">
                  <span class="sr-only">Warten ...</span>
                </div>
                <p>Bitte bleiben Sie auf dieser Seite bis der Bezahlvorgang abgeschlossen ist!</p>
              </div>
              <!-- Bitte warten ENDE -->

              <!-- Zahlung -->
              <div id="paypal" class="border border-light p-4 text-center bg-light" style="box-shadow: 0 0 15px rgba(0,0,0,0.1); display: none">
                <span class="font-weight-bold">Gewähltes Paket: </span>
                <span v-if="falldaten.umfang === 'Eine Abmahnung'"> Einmalhelfer</span>
                <span v-else> Abmahnhelfer Komplett</span>
                <div class="mb-3">
                  <span class="font-weight-bold">Preis: </span>
                  <span v-if="falldaten.umfang === 'Eine Abmahnung'"> EUR 249,00 inkl. 19% MwSt.</span>
                  <span v-else> EUR 495,00 inkl. 19% MwSt.</span>
                </div>

               <a :href="'https://bezahlen.rueden.de?token='+token" class="btn btn-success">
                 Jetzt bezahlen
               </a>

              </div>
              <!-- Zahlung ENDE -->

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rechnung bezahlt -->
    <div v-if="falldaten.rechnungBezahlt" class="col-12 col-lg-8 offset-lg-2 mb-5">
      <div class="formular-box">
        <div class="row">
          <div class="col-12 text-center">
            <div id="rechnung_bezahlt" class="border border-light p-4 text-center bg-light mb-3" style="box-shadow: 0 0 15px rgba(0,0,0,0.1);">
              <h2>Vielen Dank für die Beauftragung und die Zahlung</h2>
              <p>Sie erhalten eine Bestätigung sowie Ihre Rechnung in Kürze per E-Mail.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Rechnung bezahlt ENDE -->

      <!-- Footer -->
    <div class="col-12 mb-4 d-none">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-8 offset-lg-2 text-center text-secondary">
            &copy; 2020 - VON RUEDEN Partnerschaft von Rechtsanwälten<br />
            <b-link v-b-modal.modal-widerrufsbelehrung>Widerrufsbelehrung</b-link> &middot; <a href="#" v-b-modal.modal-datenschutzerklaerung>Datenschutzerklärung</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals -->
    <Datenschutzerklaerung/>
    <Widerrufsbelehrung/>

  </div>

</template>
<script>

let paketpreis = '249.00';
console.log(paketpreis);

import axios from 'axios'
import Schrittanzeige from '../../components/filesharing/Schrittanzeige'
import Datenschutzerklaerung from '../Datenschutzerklaerung'
import Widerrufsbelehrung from '../Widerrufsbelehrung'

export default {

  components: {
    Schrittanzeige,
    Datenschutzerklaerung,
    Widerrufsbelehrung
  },

  data() {
    return {

      schritt: 1,
      token: null,
      vmErteilt: false,

      // Fragebogen

      stammdaten: {
        anrede: null,
        vorname: null,
        nachname: null,
        strasse: null,
        plz: null,
        ort: null,
        email: null,
        telefon: null,
        geburtsdatum: null,
      },

      falldaten: {
        kanzlei: null,
        forderung: null,
        vergleichsbereitschaft: null,
        umfang: null,
        paket: null,
        rechnungBezahlt: null
      },

      dokumente: {
        abmahnung: null
      },

      unterschrift: null,
      unterschrift_typ: "automatisch",

      zustimmung_kosten: null,
      zustimmung_datenschutz_und_widerruf: null,
      zustimmung_widerruf_verzicht: null,
      zustimmung_vollmacht: null,

      // Uploads
      api: "",
      api_vm_url: "",
      uploadInProgress: false,
      files: "",
      docType: "Abmahnung",
      showFertigstellungModal: false,
      files_abmahnung: 0,
      docTypes: [ 'abmahnung' ],

      credentials: {
        sandbox: 'AcC9XLIEJbwH3g14NcJqwPYiTpYnloi42wKf79852j8TLKBbhoim2QS7cOxtSmcw858h9ju-DEgHNW9f',
        production: 'AbBeYmKtsH44yfpTyEGsRvaYgNaYo_otzmBo4lK0ujtuOOX2vHSCxlCezSQjZY8o_b9ZICy6QCrLwYFr'
      }

    }
  },

  mounted() {

    // API
    this.api = "https://formular.rueden.de/api-filesharing";

    // URL der API
    var token = this.$route.query.token;

    if (token === '' || token === undefined) {
      window.location.href = "https://www.rueden.de";
    } else {
      this.token = token;
    }

    // Unterschrift immer löschen, wenn Schritt < 5
    if (this.schritt < 4) {
      this.unterschrift = "";
    }

    // Get Lead from Flow
    this.getLead();

  },
  methods: {

    // Schritte, Validierung

    nextStep(step) {

      if(this.schritt === 2 && this.files.length === 0) {
        alert('Bitte laden Sie das Abmahnschreiben hoch.')
        return false
      }

      if (this.validateForm(step)) {
        this.schritt += 1;
      }

    },

    prevStep() {
      if (this.schritt > 1) {
        this.schritt -= 1;
      }
    },

    submitVM(e) {

      if (this.validateForm(4)) {

        e.preventDefault();

        let formData = new FormData();
        formData.append("token", this.token);
        formData.append("unterschrift", this.unterschrift);
        formData.append("unterschrift_typ", this.unterschrift_typ);
        formData.append("umfang", this.falldaten.umfang);
        formData.append("stammdaten", JSON.stringify(this.stammdaten));
        formData.append("falldaten", JSON.stringify(this.falldaten));
        formData.append("docType", this.docType);

        let _this = this;

        axios.post("https://flow.rueden.de/api/post/vollmacht", formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              _this.vmErteilt = true;
            })


      if (this.falldaten.umfang === 'Eine Abmahnung') {
        paketpreis = '249.00';
      } else {
        paketpreis = '495.00';
      }

      this.vmErteilt = true;

      document.getElementById("vielen_dank").style.display = "block";

      if (!this.falldaten.rechnungBezahlt) {
        document.getElementById("paypal").style.display = "block";
      }

      }

    },

    validateForm(id) {
      let form = document.getElementById("form_" + id);
      return form.checkValidity();
    },

    // Signatur

    undo() {
      this.$refs.signaturePad.undoSignature();
    },

    save() {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
    },

    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.unterschrift = this.$refs.signaturePad.saveSignature().data;
    },

    onEnd() {
      this.unterschrift = this.$refs.signaturePad.saveSignature().data;
    },

    changeSignatureMode() {
      if (this.unterschrift_typ === "automatisch") {
        this.unterschrift_typ = "manuell";
      } else {
        this.unterschrift_typ = "automatisch";
      }
    },

    chooseFile() {
      document.getElementById('files').click();
    },

    uploadFile() {

      let _this = this;

      this.files = this.$refs.files.files;
      this.uploadInProgress = true;

      let formData = new FormData();
      for( let i = 0; i < this.files.length; i++ ){
        let file = this.files[i];
        formData.append('files[' + i + ']', file);
      }
      formData.append('token', this.token);
      formData.append('docType', this.docType);

      axios.post('https://flow.rueden.de/api/post/upload', formData,
          {headers: {'Content-Type': 'multipart/form-data'}})
          .then(function () {
            _this.uploadInProgress = false;
          })
          .catch(function () {
            _this.uploadInProgress = false;
          });

    },

    removeFile(index) {
      document.querySelector('.file_'+index).style.display = 'none'
    },

    getLead() {
      let url = 'https://flow.rueden.de/api/get/lead/'+this.token;

      let _this = this;
      axios.get(url)
          .then((response) => {
            let lead = response.data;
            _this.stammdaten.anrede = lead.anrede;
            _this.stammdaten.vorname = lead.vorname;
            _this.stammdaten.nachname = lead.nachname;
            _this.stammdaten.strasse = lead.strasse;
            _this.stammdaten.plz = lead.plz;
            _this.stammdaten.ort = lead.ort;
            _this.falldaten.kanzlei = lead.kanzlei;
            _this.falldaten.forderung = lead.forderung;
            _this.vmErteilt = lead.vm_erteilt;
            _this.falldaten.vergleichsbereitschaft = lead.vergleichsbereitschaft;
            _this.falldaten.umfang = lead.umfang;
            _this.falldaten.rechnungBezahlt = lead.rechnung_bezahlt;
          })
          .then(() => {
            if( this.falldaten.umfang === 'Eine Abmahnung' ) {
              paketpreis = '249.00';
            } else {
              paketpreis = '495.00';
            }
          })
          .then(() => {
            if (this.vmErteilt) {
              _this.schritt = 4;
              if(!_this.falldaten.rechnungBezahlt) {
                document.getElementById("vielen_dank").style.display = "block";
              }
              document.getElementById("paypal").style.display = "block";
            }
          });
    }

  },

}

</script>
<style>
.pricing-table:hover {
  box-shadow: 0 0 20px rgba(0,0,0,0.2);
}
.btn-primary-click {
  color: #003764;
  padding: 0.375rem 1.7rem;
  background: #b6db00 !important;
}
.btn-primary-click:hover,
a.btn-primary-click:hover{
  color: #fff !important;
  background: #638c1c !important;
}
</style>